/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentVorlageDatenRequest { 
    beschreibung?: string;
    titel: string;
    ist_verantwortlichkeit_abteilung?: boolean;
    ist_verantwortlichkeit_zentrale?: boolean;
    verantwortlichkeit_funktionsbereich_id?: string;
    delegation_funktionsbereich_id?: string;
    delegation_rolle_id?: string;
    incident_vorlage_id: string;
}

